import { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import { ReactComponent as IconLocation } from "../img/icons/location.svg";
import { ReactComponent as IconInfos } from "../img/icons/infos.svg";
import { ReactComponent as IconOrientation } from "../img/icons/orientation.svg";
import { ReactComponent as IconSurface } from "../img/icons/surface.svg";
import { ReactComponent as IconResults } from "../img/icons/results.svg";

import SimulationContext from "../contexts/Simulation";
import SimWrapper from "../SimWrapper";

const Tabs = ({ steps, step }) => {
  const [simParams] = useContext(SimulationContext);

  return (
    <ul className={'steps step' + step}>
      { steps.map((curstep, index) => {
          if (index === step)
            return (<li key={curstep.key} className="active"><Button link={`/simulateur/${curstep.key}`} IconBefore={curstep.icon}>{curstep.label}</Button></li>);
          else
            return (<li key={curstep.key} ><Link to={(simParams.completeSteps >= index) ? `/simulateur/${curstep.key}` : null}><curstep.icon/>{curstep.label}</Link></li>);
        })
      }
    </ul>
  );
}

const Stepper = ({step, children}) => {
  const steps = [
    { 'key': 'localisation', 'label': 'Localisation', 'icon': IconLocation},
    { 'key': 'orientation', 'label': 'Orientation', 'icon': IconOrientation},
    { 'key': 'surface', 'label': 'Surface', 'icon': IconSurface},
    { 'key': 'informations', 'label': 'Informations', 'icon': IconInfos},
    { 'key': 'resultats', 'label': 'Résultats', 'icon': IconResults }
  ];

  useEffect(() => {
    const body = document.querySelector('body');
    steps.forEach((v, k) => { body.classList.remove('sim-step' + k); });
    body.classList.add('sim-step' + step);
    if (step === 'begin')
    {
      body.classList.remove('sim-clear');
      body.classList.add('sim-dark');
    }else{
      body.classList.remove('sim-dark');
      body.classList.add('sim-clear');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return (
    <SimWrapper step={step} Tabs={() => (step !== 'begin') && <Tabs steps={steps} step={step}/>}>
      <div className={'content step' + step}>
        { children }
      </div>
    </SimWrapper>
  );
}

export default Stepper;